import Vue from 'vue';
import Label from './Label.vue';
import Input from './Input.vue';
import Button from './Button.vue';
import InplaceProgressBar from './InplaceProgressBar.vue';
import Page from './Page.vue';
import TreeDropDown from './TreeDropDown.vue';
import Icon from './Icon.vue';
import ProductFilter from './ProductFilter.vue';
import Consist from './Consist.vue';
import Switcher from './Switcher.vue';

// Npm packages
import Tabs from 'vue-tabs-component';

export function registerControls() {
    Vue.component('Label', Label);
    Vue.component('Input', Input);
    Vue.component('Button', Button);
    Vue.component('InplaceProgressBar', InplaceProgressBar);
    Vue.component('Page', Page);
    Vue.component('TreeDropDown', TreeDropDown);
    Vue.component('Icon', Icon);
    Vue.component('ProductFilter', ProductFilter);
    Vue.component('Consist', Consist);
    Vue.component('Switcher', Switcher);

    Vue.use(Tabs);
}

export {
    Label,
    Input,
    Button,
    InplaceProgressBar,
    Page,
    TreeDropDown,
    Icon,
    ProductFilter,
    Consist,
    Switcher
};
